import React, { useContext, useEffect } from 'react';
import { ReactComponent as IncrementIcon } from '../../../images/increment.svg';
import { ReactComponent as DecrementIcon } from '../../../images/decrement.svg';
import 'office-ui-fabric-react/dist/css/fabric.css';
import './SampleProfileCardsSection.sass';
import { ThemeContext } from '@fluentui/react-theme-provider';
import styled from 'styled-components';
import { Button } from '../../buttons/MainButton';
import * as Component from './SampleProfileCardsSectionStyles';

type Props =
{
    year: string,
    performance2Year: string,
    performance3Year: string,
    performance5Year: string,
    ytd: string,
    theme: any
}
export const CardButton = styled(Button.Primary)`
    margin-top: 3.3em;
    margin-bottom: 0px;
`;

const SampleProfileCardsSection: React.FC<Props> = (props: Props) =>
{
    const theme = useContext(ThemeContext);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [mQuery, setMQuery] = React.useState<any>(
    {
        matches: window.innerWidth <= 1366 ? true : false,
    });
    useEffect(() =>
    {
        let mediaQuery = window.matchMedia("(min-width: 1366px)");
        mediaQuery.addEventListener("change", setMQuery);

        return () => mediaQuery.removeEventListener("change", setMQuery);
    }, []);


    return(
        <Component.DivContainerRow className="ms-Grid-row rowHeight">
            <Component.DivContainerCol className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl8 ms-xxl8">
                <Component.DivPrincipalRow className="ms-Grid-row rowHeight">
                    <Component.DivRowYTD key="year" className="ms-Grid-col ms-sm4 ms-md4 ms-lg2 ms-xl2 ms-xxl2 ms-xxxl2 colMargin">
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>AÑO</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCard>
                                <Component.NumberFormatDiv>
                                    {props.year < "0,00" && <DecrementIcon />}
                                    {props.year > "0,00" && <IncrementIcon />}
                                </Component.NumberFormatDiv>
                                <Component.DataText>{props.year}</Component.DataText>
                            </Component.DataCard>
                        </Component.ContainerCard>
                    </Component.DivRowYTD>
                    <Component.DivRowYTD key="performance2Y" className="ms-Grid-col ms-sm4 ms-md4 ms-lg2 ms-xl2 ms-xxl2 ms-xxxl2 colMargin">
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>2Y</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCard>
                                <Component.NumberFormatDiv>
                                    {props.performance2Year < "0,00" && <DecrementIcon />}
                                    {props.performance2Year > "0,00" && <IncrementIcon />}
                                </Component.NumberFormatDiv>
                                <Component.DataText>{props.performance2Year}</Component.DataText>
                            </Component.DataCard>
                        </Component.ContainerCard>
                    </Component.DivRowYTD>
                    <Component.DivRowYTD key="performance3Y" className="ms-Grid-col ms-sm4 ms-md4 ms-lg2 ms-xl2 ms-xxl2 ms-xxxl2 colMargin">
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>3Y</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCard>
                                <Component.NumberFormatDiv>
                                    {props.performance3Year < "0,00" && <DecrementIcon />}
                                    {props.performance3Year > "0,00" && <IncrementIcon />}
                                </Component.NumberFormatDiv>
                                <Component.DataText>{props.performance3Year}</Component.DataText>
                            </Component.DataCard>
                        </Component.ContainerCard>
                    </Component.DivRowYTD>
                    <Component.DivRowYTD key="performance5Y" className="ms-Grid-col ms-sm4 ms-md4 ms-lg2 ms-xl2 ms-xxl2 ms-xxxl2 colMargin">
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>5Y</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCard>
                                <Component.NumberFormatDiv>
                                    {props.performance5Year < "0,00" && <DecrementIcon />}
                                    {props.performance5Year > "0,00" && <IncrementIcon />}
                                </Component.NumberFormatDiv>
                                <Component.DataText>{props.performance2Year}</Component.DataText>
                            </Component.DataCard>
                        </Component.ContainerCard>
                    </Component.DivRowYTD>
                    <Component.DivRowYTD key="ytd" className="ms-Grid-col ms-sm4 ms-md4 ms-lg2 ms-xl2 ms-xxl2 ms-xxxl2 colMargin">
                        <Component.ContainerCard theme={theme}>
                            <Component.TitleCard>
                                <Component.TitleText theme={theme}>YTD</Component.TitleText>
                            </Component.TitleCard>
                            <Component.DataCard>
                                <Component.NumberFormatDiv>
                                    {props.ytd < "0,00" && <DecrementIcon />}
                                    {props.ytd > "0,00" && <IncrementIcon />}
                                </Component.NumberFormatDiv>
                                <Component.DataText>{props.ytd}</Component.DataText>
                            </Component.DataCard>
                        </Component.ContainerCard>
                    </Component.DivRowYTD>
                   
                </Component.DivPrincipalRow>
            </Component.DivContainerCol>
            <Component.DivColEmpty className="ms-Grid-col ms-hiddenLgDown ms-xl1 ms-xxl1" />
        </Component.DivContainerRow>
    );
}

export default SampleProfileCardsSection;